import { MenuItem } from '@material-ui/core';
import React from 'react';

import useManufacturers from 'core/hooks/useManufacturers';
import { InputField, InputFieldProps } from 'Elements/Form';

export default function ManufacturerSelect({
  name = 'manufacturer_id',
  ...props
}: InputFieldProps) {
  const manufacturers = useManufacturers();

  return (
    <InputField
      name={name}
      select
      margin="normal"
      InputLabelProps={{
        shrink: true
      }}
      {...props}
    >
      {manufacturers.map(manufacturer => (
        <MenuItem key={manufacturer.id} value={manufacturer.id}>
          {manufacturer.name}
        </MenuItem>
      ))}
    </InputField>
  );
}
